import client from './client';

export const getProvisioningStatus = async () => {
  const res = await client.get('/api/whatsapp/provisioning-status');
  return res.data;
};

export const connectFacebook = async (data) => {
  const res = await client.post('/api/whatsapp/connect-facebook', data);
  return res.data;
};

export const getSettings = async () => {
  const res = await client.get('/api/whatsapp/settings');
  return res.data;
};

export const saveSettings = async (data) => {
  const res = await client.put('/api/whatsapp/settings', data);
  return res.data;
};

export const updateAccountDetails = async (data) => {
  const res = await client.put('/api/whatsapp/account', data);
  return res.data;
};

export const disconnect = async () => {
  const res = await client.post('/api/whatsapp/disconnect');
  return res.data;
};

export const requestOtp = async (method = 'SMS') => {
  const res = await client.post('/api/whatsapp/request-otp', { method });
  return res.data;
};

export const verifyOtp = async (code) => {
  const res = await client.post('/api/whatsapp/verify-otp', { code });
  return res.data;
};

export const markPaymentDone = async (planId) => {
  const res = await client.post('/api/whatsapp/payment/mark-paid', { planId });
  return res.data;
};

export const submitOnboarding = async (data) => {
  const res = await client.post('/api/whatsapp/submit-onboarding', data);
  return res.data;
};

export const registerClientPhone = async (cc, phoneNumber) => {
  const res = await client.post('/api/whatsapp/register-phone', { cc, phoneNumber });
  return res.data;
};

export const claimPhone = async (phoneNumberId, wabaId, clientAccessToken = '') => {
  const res = await client.post('/api/whatsapp/claim-phone', { phoneNumberId, wabaId, clientAccessToken });
  return res.data;
};

export const resetPhone = async () => {
  const res = await client.post('/api/whatsapp/reset-phone');
  return res.data;
};

export const exportConversations = async () => {
  const res = await client.get('/api/whatsapp/conversations/export', { responseType: 'blob' });
  return res.data;
};

export const getCampaigns = async () => {
  const res = await client.get('/api/whatsapp/campaigns');
  return res.data;
};

export const createCampaign = async (data) => {
  const res = await client.post('/api/whatsapp/campaigns/create', data);
  return res.data;
};

export const sendCampaign = async (id) => {
  const res = await client.post(`/api/whatsapp/campaigns/${id}/send`);
  return res.data;
};

export const getTemplates = async () => {
  const res = await client.get('/api/whatsapp/templates');
  return res.data;
};

export const deleteCampaign = async (id) => {
  const res = await client.delete(`/api/whatsapp/campaigns/${id}`);
  return res.data;
};

export const importContacts = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const res = await client.post('/api/whatsapp/contacts/import', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return res.data;
};

export const getContacts = async (params = {}) => {
  const res = await client.get('/api/whatsapp/contacts', { params });
  return res.data;
};

export const updateContact = async (id, data) => {
  const res = await client.put(`/api/whatsapp/contacts/${id}`, data);
  return res.data;
};

export const deleteContact = async (id) => {
  const res = await client.delete(`/api/whatsapp/contacts/${id}`);
  return res.data;
};

// Chatbot Flows
export const getFlows = async (params = {}) => {
  const res = await client.get('/api/whatsapp/flows', { params });
  return res.data;
};

export const getFlow = async (id) => {
  const res = await client.get(`/api/whatsapp/flows/${id}`);
  return res.data;
};

export const createFlow = async (data) => {
  const res = await client.post('/api/whatsapp/flows', data);
  return res.data;
};

export const updateFlow = async (id, data) => {
  const res = await client.put(`/api/whatsapp/flows/${id}`, data);
  return res.data;
};

export const deleteFlow = async (id) => {
  const res = await client.delete(`/api/whatsapp/flows/${id}`);
  return res.data;
};
